<div class="row">
  <h3 class="col">Distribuição de limites - Agente</h3>
  <div class="col-auto">
    <button class="btn btn-primary" (click)="voltar()">Voltar</button>
  </div>
</div>

<div class="container">
  <ul ngbNav #nav="ngbNav" class="nav-tabs">
    <li [ngbNavItem]>
      <button ngbNavLink>Geral</button>
      <ng-template ngbNavContent>
        <div class="row mb-4">
          <div class="col-6">
            <label><b>Nome</b></label>
            <input type="text" class="form-control" [value]="detalheAgente?.nomeAgente" disabled>
          </div>
          <div class="col-3">
            <label><b>CNPJ</b></label>
            <input type="text" class="form-control" [value]="detalheAgente?.cnpjAgente | bnMask : 'CNPJ'" disabled>
          </div>
          <div class="col-3">
            <label><b>Data de criação</b></label>
            <input type="text" class="form-control" [value]="detalheAgente?.dataCriacao | date: 'dd/MM/yyyy HH:mm:ss'" disabled>
          </div>
        </div>
        <div class="mb-4">
          <h4 class="col">Primeira Distribuição</h4>
          <div class="row mb-3">
            <div class="col-3">
              <label><b>Fator redutor</b></label>
              <input type="text" class="form-control" [value]="detalheAgente?.fatorRedutorPrimeiraDistribuicao" disabled>
            </div>
            <div class="col-3">
              <label><b>Valor disponível início do ciclo</b></label>
              <input type="text" class="form-control" [value]="detalheAgente?.valorLimiteDisponivelInicioCiclo | bnMask: 'MOEDA'" disabled>
            </div>
            <div class="col-3">
              <label><b>Valor complementar recebido</b></label>
              <input type="text" class="form-control" [value]="detalheAgente?.valorLimiteComplementarRecebidoPrimeiraDistribuicao | bnMask: 'MOEDA'" disabled>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-3">
              <label><b>Valor estipulado meta 1</b></label>
              <input type="text" class="form-control" [value]="detalheAgente?.valorEstipuladoMeta1PrimeiraDistribuicao | bnMask: 'MOEDA'" disabled>
            </div>
            <div class="col-3">
              <label><b>Valor atingido meta 1</b></label>
              <input type="text" class="form-control" [value]="detalheAgente?.valorAtingidoMeta1PrimeiraDistribuicao | bnMask: 'MOEDA'" disabled>
            </div>
            <div class="col-3">
              <label><b>Valor estipulado meta 2</b></label>
              <input type="text" class="form-control" [value]="detalheAgente?.valorEstipuladoMeta2PrimeiraDistribuicao | bnMask: 'MOEDA'" disabled>
            </div>
            <div class="col-3">
              <label><b>Valor atingido meta 2</b></label>
              <input type="text" class="form-control" [value]="detalheAgente?.valorAtingidoMeta2PrimeiraDistribuicao | bnMask: 'MOEDA'" disabled>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-3">
              <label><b>Valor estipulado meta 3</b></label>
              <input type="text" class="form-control" [value]="detalheAgente?.valorEstipuladoMeta3PrimeiraDistribuicao | bnMask: 'MOEDA'" disabled>
            </div>
            <div class="col-3">
              <label><b>Valor atingido meta 3</b></label>
              <input type="text" class="form-control" [value]="detalheAgente?.valorAtingidoMeta3PrimeiraDistribuicao | bnMask: 'MOEDA'" disabled>
            </div>
            <div class="col-3">
              <label><b>Valor estipulado meta 4</b></label>
              <input type="text" class="form-control" [value]="detalheAgente?.valorEstipuladoMeta4PrimeiraDistribuicao | bnMask: 'MOEDA'" disabled>
            </div>
            <div class="col-3">
              <label><b>Valor atingido meta 4</b></label>
              <input type="text" class="form-control" [value]="detalheAgente?.valorAtingidoMeta4PrimeiraDistribuicao | bnMask: 'MOEDA'" disabled>
            </div>
          </div>
        </div>
        <div>
          <h4>Segunda Distribuição</h4>
          <div class="mb-4">
            <div class="row">
              <div class="col-3">
                <label><b>Valor complem. recebido (calculado)</b></label>
                <input type="text" class="form-control" [value]="detalheAgente?.valorLimiteComplementarRecebidoSegundaDistribuicaoCalculado | bnMask: 'MOEDA'" disabled>
              </div>
              <div class="col-3">
                <label><b>Valor complem. recebido (realizado)</b></label>
                <input type="text" class="form-control" [value]="detalheAgente?.valorLimiteComplementarRecebidoSegundaDistribuicaoRealizado | bnMask: 'MOEDA'" disabled>
              </div>
              <div class="col-3">
                <label><b>Valor estipulado da meta</b></label>
                <input type="text" class="form-control" [value]="detalheAgente?.valorEstipuladoMetaSegundaDistribuicao | bnMask: 'MOEDA'" disabled>
              </div>
              <div class="col-3">
                <label><b>Valor atingido da meta</b></label>
                <input type="text" class="form-control" [value]="detalheAgente?.valorAtingidoMetaSegundaDistribuicao | bnMask: 'MOEDA'" disabled>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h4>Terceira Distribuição</h4>
          <div class="mb-4">
            <div class="row">
              <div class="col-3">
                <label><b>Valor complem. recebido (calculado)</b></label>
                <input type="text" class="form-control" [value]="detalheAgente?.valorLimiteComplementarRecebidoTerceiraDistribuicaoCalculado | bnMask: 'MOEDA'" disabled>
              </div>
              <div class="col-3">
                <label><b>Valor complem. recebido (realizado)</b></label>
                <input type="text" class="form-control" [value]="detalheAgente?.valorLimiteComplementarRecebidoTerceiraDistribuicaoRealizado | bnMask: 'MOEDA'" disabled>
              </div>
              <div class="col-3">
                <label><b>Valor estipulado da meta</b></label>
                <input type="text" class="form-control" [value]="detalheAgente?.valorEstipuladoMetaTerceiraDistribuicao | bnMask: 'MOEDA'" disabled>
              </div>
              <div class="col-3">
                <label><b>Valor atingido da meta</b></label>
                <input type="text" class="form-control" [value]="detalheAgente?.valorAtingidoMetaTerceiraDistribuicao | bnMask: 'MOEDA'" disabled>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]>
      <button ngbNavLink>Ciclo</button>
      <ng-template ngbNavContent>
        <div class="row mb-3">
          <div class="col-3">
            <label><b>Limite disponível início ciclo</b></label>
            <input type="text" class="form-control" [value]="detalheAgente.valorLimiteDisponivelInicioCiclo | bnMask : 'MOEDA'" disabled>
          </div>
          <div class="col-3">
            <label><b>Limite total início ciclo</b></label>
            <input type="text" class="form-control" [value]="detalheAgente.valorLimiteTotalInicioCiclo | bnMask : 'MOEDA'" disabled>
          </div>
          <div class="col-3">
            <label><b>Valor consumido ciclo anterior</b></label>
            <input type="text" class="form-control" [value]="detalheAgente.valorConsumidoCicloAnterior | bnMask : 'MOEDA'" disabled>
          </div>
          <div class="col-3">
            <label><b>Total contratado ciclo</b></label>
            <input type="text" class="form-control" [value]="detalheAgente.valorTotalContratadoNoCiclo | bnMask : 'MOEDA'" disabled>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-3">
            <label><b>Total contratado adicional anteriores</b></label>
            <input type="text" class="form-control" [value]="detalheAgente.valorTotalContratadoAdicionalRefCiclosAnteriores | bnMask : 'MOEDA'" disabled>
          </div>
          <div class="col-3">
            <label><b>Total cancelado anteriores</b></label>
            <input type="text" class="form-control" [value]="detalheAgente.valorTotalCanceladoRefCiclosAnteriores | bnMask : 'MOEDA'" disabled>
          </div>
          <div class="col-3">
            <label><b>Total redução anteriores</b></label>
            <input type="text" class="form-control" [value]="detalheAgente.valorTotalReducaoRefCiclosAnteriores | bnMask : 'MOEDA'" disabled>
          </div>
          <div class="col-3">
            <label><b>Limite disponivel fim ciclo</b></label>
            <input type="text" class="form-control" [value]="detalheAgente.valorLimiteDisponivelFimCiclo | bnMask : 'MOEDA'" disabled>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-3">
            <label><b>Total contratado de limite adicional</b></label>
            <input type="text" class="form-control" [value]="detalheAgente.valorTotalContratadoNoCicloDeLimiteAdicional | bnMask : 'MOEDA'" disabled>
          </div>
          <div class="col-3">
            <label><b>Total renuncia ciclo</b></label>
            <input type="text" class="form-control" [value]="detalheAgente.valorTotalRenunciaNoCiclo | bnMask : 'MOEDA'" disabled>
          </div>
          <div class="col-3">
            <label><b>Limite complem. recebido renúncia</b></label>
            <input type="text" class="form-control" [value]="detalheAgente.valorLimiteComplementarRecebidoRenuncia | bnMask : 'MOEDA'" disabled>
          </div>
          <div class="col-3">
            <label><b>Limite complem. recebido renún. bolo</b></label>
            <input type="text" class="form-control" [value]="detalheAgente.valorLimiteComplementarRecebidoRenunciaDoBolo | bnMask : 'MOEDA'" disabled>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-auto">
            <label><b>Agente tem operação com limite adicional no ciclo</b></label>
            <input type="checkbox" class="form-check checkbox-gigante" [value]="detalheAgente.agenteTemOperacaoComLimiteAdicionalNoCiclo" disabled>
          </div>
        </div>
      </ng-template>
    </li>
    @if (detalheAgente?.distribuicaoApuracaoRenuncia) {
      <li [ngbNavItem]>
        <button ngbNavLink>Apuração Renúncia</button>
        <ng-template ngbNavContent>
          <div class="row mb-3">
            <div class="col-3">
              <label><b>Valor Renunciado</b></label>
              <input type="text" class="form-control" [value]="detalheAgente.distribuicaoApuracaoRenuncia.valorRenunciado | bnMask: 'MOEDA'" disabled>
            </div>
            <div class="col-3">
              <label><b>Valor Limite Descomprometido</b></label>
              <input type="text" class="form-control" [value]="detalheAgente.distribuicaoApuracaoRenuncia.valorLimiteDescomprometido | bnMask: 'MOEDA'" disabled>
            </div>
            <div class="col-3">
              <label><b>Valor Destribuição</b></label>
              <input type="text" class="form-control" [value]="detalheAgente.distribuicaoApuracaoRenuncia.valorDistribuicao | bnMask: 'MOEDA'" disabled>
            </div>
            <div class="col-3">
              <label><b>Data da Apuração de Renúncia</b></label>
              <input type="text" class="form-control" [value]="detalheAgente.distribuicaoApuracaoRenuncia.dataApuracaoRenuncia | date: 'dd/MM/yyyy'" disabled>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-3">
              <label><b>Bimestre utilizado</b></label>
              <input type="text" class="form-control" [value]="detalheAgente.distribuicaoApuracaoRenuncia.bimestreUtilizado" disabled>
            </div>
          </div>
        </ng-template>
      </li>
    }
  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>